
<template>
  <div :class="[formGroupClass, 'form-group']">
    <label class="control-label" v-if="alias">{{ alias }}:</label>
    <vue-autonumeric
      ref="input"
      :options="{
        decimalPlaces: decimalPlaces,
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        currencySymbol: currencySymbol,
        currencySymbolPlacement: 's',
        defaultValueOverride: '1',
        emptyInputBehavior: emptyInputBehavior,
        maximumValue: maximumValue,
        minimumValue: minimumValue,
        modifyValueOnWheel: false,
      }"
      :class="[
        'form-control',
        'form-control-sm',
        'numeric',
        inputClass,
        { 'is-invalid': getError },
        { 'text-muted': shutoff },
      ]"
      v-model="modelValue"
      :name="name"
      @input="onInput"
      @blur.native="onBlur"
      @keyup.native="$emit('keyup', $event)"
      :disabled="isDisabled"
      inputmode="numeric"
    >
    </vue-autonumeric>
    <div class="invalid-feedback invalid-feedback-overwrite" v-if="getError">
      {{ getError }}
    </div>
  </div>
</template>

<script>
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  components: { VueAutonumeric },

  props: {
    /*
            - Configs -
            accepts null
            accepts negative
            currencySymbol
        */

    value: {},

    name: {},
    alias: {},

    formGroupClass: {},
    inputClass: {},

    decimalPlaces: {
      default: 2,
    },

    emptyInputBehavior: {
      default: 0,
    },

    currencySymbol: {
      default: "",
    },

    maximumValue: {
      default: 999999999,
    },

    minimumValue: {
      default: -99999999,
    },

    disabled: {
      default: false,
    },

    shutoff: {
      default: false,
    },

    form: {},
    error: {},
  },

  data() {
    return {
      modelValue: null,
      storedVal: null,
    };
  },

  created() {
    this.setValue(this.value);
  },

  watch: {
    value: function (newValue, oldValue) {
      this.setValue(newValue);
    },

    shutoff: function (newValue, oldValue) {
      if (newValue) {
        this.storedVal = this.modelValue;
        this.modelValue = "";
      } else {
        this.modelValue = this.storedVal;
      }
    },
  },

  computed: {
    getError() {
      if (this.form !== {} && this.form !== undefined) {
        return this.form.getErrors(this.name);
      }
      return false;
    },

    isDisabled() {
      return this.disabled || this.shutoff;
    },
  },

  methods: {
    setValue(value) {
      if (this.shutoff) {
        this.modelValue = "";
      } else {
        this.storedVal = this.value;
        this.modelValue = value;
      }
    },

    onInput(event) {
      this.$emit("input", this.modelValue);
    },

    focus() {
      this.$refs.input.$el.focus();
    },

    onBlur(event) {
      // resolve the problem when erases all text in the input, its remains
      // the with empty value, but the model stays in 0, now
      // when erases, it will replace with 0,00
      // if (this.value == 0){
      //     this.modelValue = '0'
      // }

      this.$emit("blur");
      this.validate(event);
    },

    validate(event) {
      if (this.form != undefined) {
        this.form.validate(this.name);
      }
    },
  },
};
</script>

<style>
.numeric {
  text-align: right;
}
</style>

